import React from 'react';
import { motion, useReducedMotion } from 'motion/react';
import { EASE_OUT, REVEAL_DURATION, VIEWPORT } from '../../lib/motion';

// Content arrives blurred and slightly low, then settles. `delay` is in seconds.
const Reveal = ({ as = 'div', delay = 0, y = 28, blur = true, amount, className, children, ...rest }) => {
  const reduced = useReducedMotion();
  const Tag = motion[as] || motion.div;

  if (reduced) {
    return <Tag className={className} {...rest}>{children}</Tag>;
  }

  return (
    <Tag
      className={className}
      initial={{ opacity: 0, y, filter: blur ? 'blur(10px)' : 'blur(0px)' }}
      whileInView={{ opacity: 1, y: 0, filter: 'blur(0px)' }}
      viewport={amount ? { ...VIEWPORT, amount } : VIEWPORT}
      transition={{ duration: REVEAL_DURATION, ease: EASE_OUT, delay }}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export default Reveal;
